export default {
	section_banner: {
		title: {
			one: 'Pay',
			two: 'at your',
		},
		main_title: {
			one: 'Go-To Store',
		},
		sub_title: {
			one: 'with',
			two: 'JPWorldPay',
		},
		paragraph: {
			one: 'Customers can quickly make payments themselves. Please try JPWorldPay,',
			two: 'which allows you to pay immediately with a mobile phone without cash or card.',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},
	qr_pay: {
		label: '3 Steps Payment',
		title: {
			one: 'QR Pay',
			two: 'With JPWorldPay',
		},
		paragraph:
			'Tap the QR icon on your iPhone, select Scan when the seller presents the code, or tap Show to pay if you are requesting a QR code - quick, simple, and secure every time.',
		white_box_1st: {
			heading: 'Scan or Show',
			paragraph: 'Scan or show your code to complete payment with JPWorldPay.',
		},
		white_box_2nd: {
			heading: 'Make Payment',
			paragraph: 'Make seamless payments anytime with JPWorldPay.',
		},
		white_box_3rd: {
			heading: 'Pay With Us',
			paragraph: 'Pay with the cryptocurrency you want on JPWorldPay.',
		},
	},
	future_currency_sec: {
		label: 'JPWorldPay Wallet',
		title: {
			one: 'Welcome To The',
			two: 'Future Currency',
			three: 'System',
		},
		future_white_box_1st: {
			heading: 'Secure Payment',
			paragraph:
				'JPWorldPay does not disclose your information during QR code transactions.',
		},
		future_white_box_2nd: {
			heading: 'Any Company',
			paragraph:
				'Pay instantly and securely at offline merchants anywhere, 24 hours a day.',
		},
		future_white_box_3rd: {
			heading: 'Touch Free',
			paragraph:
				'Do not worry about cash or credit card- open the application and pay.',
		},
	},
	online_mid: {
		label: 'Fastest Payment System',
		title: {
			one: 'We Hope You',
			two: 'Enjoy',
			three: 'It Again',
		},
		paragraph: {
			one: 'When you buy with JPWorldPay, you earn points for future purchases. JPWorldPay points are accepted at all merchants who use JPWorldPay, making it easy and rewarding to shop and save. Enjoy seamless transactions and unlock great savings with every purchase. Plus, enjoy exclusive offers and discounts available only to JPWorldPay users.',
		},
		cta_buttons: {
			one: 'Get Started',
		},
	},
	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
